// extracted by mini-css-extract-plugin
export default {"mapElement":"EnglandMap_mapElement__Aqht7","pageContents":"EnglandMap_pageContents__wNWc4","introText":"EnglandMap_introText__yqX3c"};